import Sortable from "sortablejs";

function initSortable(elId, paramKey) {
  const el = document.getElementById(elId);
  if (!el) return;

  Sortable.create(el, {
    animation: 150,
    handle: ".drag-handle",
    onEnd: () => {
      const url = el.dataset.url;
      const items = [...el.querySelectorAll("[data-id]")].map((li, index) => ({
        id: li.dataset.id,
        ordering: index + 1,
      }));

      const token = document.querySelector("[name=csrf-token]").content;

      fetch(url, {
        method: "PATCH",
        credentials: "same-origin",
        headers: { "X-CSRF-TOKEN": token, "content-type": "application/json" },
        body: JSON.stringify({ [paramKey]: items }),
      }).then((res) => {
        if (res.ok) {
          const alert = document.getElementById("reorder-success-alert");
          alert.classList.remove("d-none");
          setTimeout(() => alert.classList.add("d-none"), 2000);
        }
      });
    },
  });
}

document.addEventListener("DOMContentLoaded", () => {
  initSortable("sortable-collections", "posts_collections");
  initSortable("sortable-feature-posts", "feature_posts_collections");
});
